import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setMemberInfoErrorModalVisible } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/MemberInfoErrorModal/types';
import Modal from 'components/Modal';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import { useFormikContext } from 'formik';
import _ from 'lodash';

const MemberInfoErrorModal: React.FC<IProps> = (props) => {
    const { setFieldTouched } = useFormikContext();

    const handleConfirm = () => {
        handleClose();
        if (!props.modal.memberInfoErrorModalState.fieldNames ||
            props.modal.memberInfoErrorModalState.fieldNames.length === 0
        ) return;

        _.forEach(props.modal.memberInfoErrorModalState.fieldNames, (fieldName: string) => {
            setFieldTouched(fieldName, true);
        });
    };

    const handleClose = () => {
        props.setMemberInfoErrorModalVisible(false);
    };

    return (
        <>
            {props.modal.memberInfoErrorModalState.visible && (
                <Modal
                    visible={props.modal.memberInfoErrorModalState.visible}
                    icon={SweetAlertIcon.Info}
                    title={props.modal.memberInfoErrorModalState.title || ''}
                    cancelButton={false}
                    closeIcon={false}
                    onConfirm={handleConfirm}
                >
                    <p className="element__part" style={{ fontSize: '18px' }}>{props.modal.memberInfoErrorModalState.content}</p>
                </Modal>
            )}
        </>
    );
};

const mapStateToProps = (state: RootReducersState) => ({
    modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setMemberInfoErrorModalVisible: (visible: boolean, title?: string, content?: string, fieldNames?: string[]) => dispatch(setMemberInfoErrorModalVisible(visible, title, content, fieldNames))
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberInfoErrorModal);
